<rid-lingo class="h-dvh" [assignments]="assignments" [attempts]="6" (finished)="$router.navigate(['/mechanics/games'])" />
